tailwind.config = {
  theme: {
    fontSize: {
      sm: '0.8rem',
      base: '1rem',
      lg: '1.2rem',
      xl: '1.4rem',
      '2xl': '1.6rem',
      '3xl': '1.8rem',
      '4xl': '2rem',
      '5xl': '2.5rem',
      '6xl': '3rem',
      '7xl': '3.5rem',
    },
    extend: {
      screens: {
        sm: '480px',
        md: '720px',
        lg: '960px',
        xl: '1200px',
        max: '1440px'
      },
      colors: {
        main: '#0B2CF9',
      },
    },
  }
}